import type { FC, MouseEvent, ReactNode } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'
import { cn } from '@/lib/utils'

interface LogoLinkProps {
    children: ReactNode
    className?: string
}

// Brand link to home. On other pages it navigates to /, on the home page it
// smooth-scrolls to the top so the visitor always lands at the start.
const LogoLink: FC<LogoLinkProps> = ({ children, className }): ReactNode => {
    const { pathname } = useRouter()

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        if (pathname === '/') {
            event.preventDefault()
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    return (
        <Link
            href='/'
            onClick={handleClick}
            aria-label="Dhurata e Bajramit — kthehu në ballinë"
            className={cn(
                'inline-flex shrink-0 rounded-pill focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-yellow/60',
                className
            )}
        >
            {children}
        </Link>
    )
}

export default LogoLink
